(function () {
  window.warehouse = window.warehouse || {};
  window.warehouse.classes = window.warehouse.classes || {};
  function beforeWarehouseBoot(callback) {
    const defineCustomElement = window.customElements.define;
    window.customElements.define = function (name, constructor, options) {
      if (name === 'price-range') callback();
      return defineCustomElement.call(this, name, constructor, options);
    };
  }

  function isValuePicker(constructor) {
    return constructor?.toString().includes('this.isOpen') && constructor?.toString().includes('this.togglerElement');
  }

  function isSectionContainer(constructor) {
    return constructor?.toString().includes('_attachListeners') && constructor?.toString().includes('this.instances');
  }

  function isCollectionSection(constructor) {
    return (
      constructor?.toString().includes('_attachListeners') &&
      constructor?.toString().includes('this.mobileFilterDrawer')
    );
  }

  function isProductVariants(constructor) {
    return constructor?.toString().includes('this.productOptionsWithValues');
  }

  function isProductGallery(constructor) {
    return (
      constructor?.toString().includes('this.viewInSpaceElement') &&
      constructor?.toString().includes('this.previouslySelectedMedia')
    );
  }

  function isCurrency(property) {
    return property?.toString().includes('formatMoney');
  }

  function isModalManager(constructor) {
    return constructor?.toString().includes('this.activeModalsQueue');
  }

  function isCart(constructor) {
    return (
      constructor?.toString().includes('this.miniCartElement') &&
      constructor?.toString().includes('this.isMiniCartOpen')
    );
  }

  const defineProperty = Object.defineProperty;
  Object.defineProperty = function (object, property, descriptor) {
    if (isValuePicker(object?.constructor)) window.warehouse.classes.ValuePicker = object;
    if (isSectionContainer(object?.constructor)) window.warehouse.classes.SectionContainer = object;
    if (isCollectionSection(object?.constructor)) window.warehouse.classes.CollectionSection = object;
    if (isProductVariants(object?.constructor)) window.warehouse.classes.ProductVariants = object;
    if (isProductGallery(object?.constructor)) window.warehouse.classes.ProductGallery = object;
    if (isCurrency(property)) window.warehouse.classes.Currency = object;
    if (isModalManager(object?.constructor)) window.warehouse.classes.ModalManager = object;
    if (isCart(object?.constructor)) window.warehouse.classes.Cart = object;

    return defineProperty(object, property, descriptor);
  };

  function updateValuePicker(ValuePicker) {
    const _attachListeners = ValuePicker._attachListeners;

    ValuePicker._attachListeners = function () {
      return _attachListeners.call(this);
    };
  }

  function updateProductGallery(ProductGallery) {
    const _createCarousel = ProductGallery._createCarousel;

    ProductGallery._createCarousel = function () {
      _createCarousel.call(this);
      const buttons = document.querySelectorAll('.scroller__button');
      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          if (event.target.classList.contains('scroller__button--prev')) {
            this.flickityInstance.previous();
          } else {
            this.flickityInstance.next();
          }
        });
      });
    };
  }

  function updateProductVariants(ProductVariants) {
    const _attachListeners = ProductVariants._attachListeners;
    const _onVariantChanged = ProductVariants._onVariantChanged;
    const _updateProductPrices = ProductVariants._updateProductPrices;
    const _updateAddToCartButton = ProductVariants._updateAddToCartButton;

    // eslint-disable-next-line func-style
    const _updateTitle = function (newVariant) {
      if (!newVariant || !newVariant.name) return;
      // eslint-disable-next-line babel/no-invalid-this
      this.element.querySelector('.product-meta__title').innerHTML = newVariant.name;
    };

    ProductVariants._attachListeners = function (pushState) {
      document.addEventListener('select:change', (event) => {
        // eslint-disable-next-line no-useless-call
        this._onOptionChanged.call(this, event, event.detail.target);
      });
      const result = _attachListeners.call(this, pushState);

      // Fix: Correct button state after constructor modifies it
      // The constructor activates the button after _attachListeners (lines 3370-3373),
      // so we need to fix it after the constructor finishes
      const addToCartButton = this.element.querySelector('.product-form__add-button');
      if (addToCartButton && this.currentVariant) {
        // Use double requestAnimationFrame to ensure this runs after constructor completes
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (this.currentVariant) {
              this._updateAddToCartButton(this.currentVariant);
            }
          });
        });
      }

      return result;
    };

    ProductVariants._updateDiscountLabel = function () {
      return null;
    };

    ProductVariants._onVariantChanged = function (previousVariant, newVariant) {
      _onVariantChanged.call(this, previousVariant, newVariant);
      _updateTitle.call(this, newVariant);

      const add_to_wishlist_variant = this.element.querySelector('.add-to-wishlist').querySelector('[data-variant]');
      add_to_wishlist_variant.setAttribute('data-variant', newVariant?.id);
      if (typeof window.$ === 'function') window.$(add_to_wishlist_variant).data('variant', newVariant?.id);
      typeof window.ReloadSmartWishlist === 'function' && window.ReloadSmartWishlist();
    };

    ProductVariants._updateProductPrices = function (newVariant, previousVariant) {
      _updateProductPrices.call(this, newVariant, previousVariant);

      if (!newVariant || !(newVariant.price < newVariant.compare_at_price)) return;
      if (newVariant.id === previousVariant?.id) return;
      let savings = null;

      if (window.theme.discountMode === 'percentage') {
        savings = ''.concat(
          Math.round(((newVariant.compare_at_price - newVariant.price) * 100) / newVariant.compare_at_price),
          '%',
        );
      } else {
        savings = '<span>'.concat(
          window.warehouse.classes.Currency.formatMoney(
            newVariant.compare_at_price - newVariant.price,
            window.theme.moneyFormat,
          ),
          '</span>',
        );
      }
      const label = this.element.querySelector('.price--on-sale');
      const newLabel = `<span class="price price--on-sale text--strong">-${savings}</span>`;
      if (label) {
        this.element.querySelector('.price--on-sale').remove();
      }
      this.element.querySelector('.price--highlight').insertAdjacentHTML('afterend', newLabel);
    };

    ProductVariants._updateAddToCartButton = function (newVariant, previousVariant) {
      const addToCartButtonElement = this.element.querySelector('.product-form__add-button');
      _updateAddToCartButton.call(this, newVariant, previousVariant);
      addToCartButtonElement.innerHTML = `${addToCartButtonElement.textContent} ${window?.icons?.cart}`;
    };
  }

  function updateCollectionSection(CollectionSection) {
    const _reload = CollectionSection._reload;
    CollectionSection._reload = function (pushState) {
      return _reload.call(this, pushState).then(() => {
        document.addEventListener(
          'theme:loading:end',
          () => {
            document.dispatchEvent(new CustomEvent('collection:change'));
          },
          { once: true },
        );
      });
    };
  }

  function updateSectionContainer(SectionContainer) {
    const _createInstance = SectionContainer._createInstance;

    SectionContainer._createInstance = function (container, constructor) {
      _createInstance.call(this, container, constructor);
      container.instance = this.instances.find((instance) => container === instance.container);
    };
  }

  function updateCurrency(Currency) {
    const formatMoney = Currency.formatMoney;

    Currency.formatMoney = function (cents, format) {
      const result = formatMoney.call(this, cents, format);
      if (window.theme.show_taxes_included) {
        return `${result}<span class="price__taxable">${window.languages.tax_reduction}</span>`;
      } else {
        return result;
      }
    };
  }

  function updateModalManager(ModalManager) {
    const _openModal = ModalManager._openModal;
    const _closeModal = ModalManager._closeModal;
    const config = {
      childList: true,
    };

    const callback = function (mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          typeof window.ReloadSmartWishlist === 'function' && window.ReloadSmartWishlist();
          document.dispatchEvent(
            new CustomEvent('modal:change', {
              detail: mutation.target,
            }),
          );
        }
      }
    };
    const observer = new MutationObserver(callback);
    ModalManager._openModal = function (event, target) {
      _openModal.call(this, event, target);
      const modal = document.getElementById(target.getAttribute('aria-controls')).querySelector('.modal__inner');
      observer.observe(modal, config);
    };

    ModalManager._closeModal = function (event, target) {
      _closeModal.call(this, event, target);
      observer.disconnect();
    };

    ModalManager._checkClickOutside = function (event) {
      if (this.activeModalsQueue.length === 0) {
        return;
      }

      let modalToClose = this.activeModalsQueue[this.activeModalsQueue.length - 1];

      if (modalToClose && modalToClose === event.target) {
        this._closeModal();
      }
    };
  }

  function updateCart(Cart) {
    const openMiniCart = Cart._openMiniCart;
    const closeMiniCart = Cart._closeMiniCart;

    Cart._openMiniCart = function () {
      openMiniCart.call(this);
      document.documentElement.classList.add('lock-all');
    };

    Cart._closeMiniCart = function () {
      closeMiniCart.call(this);
      document.documentElement.classList.remove('lock-all');
    };
  }

  beforeWarehouseBoot(() => {
    updateValuePicker(window.warehouse.classes.ValuePicker);
    updateSectionContainer(window.warehouse.classes.SectionContainer);
    updateCollectionSection(window.warehouse.classes.CollectionSection);
    updateProductVariants(window.warehouse.classes.ProductVariants);
    updateProductGallery(window.warehouse.classes.ProductGallery);
    updateCurrency(window.warehouse.classes.Currency);
    updateModalManager(window.warehouse.classes.ModalManager);
    updateCart(window.warehouse.classes.Cart);
  });
})();
